import React from 'react';
import { ProductContainer } from './products';
import { LastUpdate } from './last-update';
import { getItemsPerRow, useScreenSize } from '../../hooks/use-screen-size';

type OurImpactProps = {
    lastModified: string;
    donations: [{}];
    donationsHeadline: string;
    organizations: [{}];
    organizationsHeadline: string;
};

const OurImpact = ({
    donations,
    donationsHeadline,
    organizations,
    organizationsHeadline,
    lastModified,
}: OurImpactProps) => {

    const screenSize = useScreenSize();
    const itemsPerRow = getItemsPerRow(screenSize);

    return (
        <div className="our-impact">
            <ProductContainer
                className="donations-stats my-5"
                headline={donationsHeadline}
                itemsPerRow={itemsPerRow}
                items={donations}
                cardBackground
            />
            <ProductContainer
                className="organizations-stats"
                headline={organizationsHeadline}
                itemsPerRow={itemsPerRow}
                items={organizations}
            />
            <LastUpdate date={lastModified} />
        </div>
    );
};

export class OurImpactWrapper extends React.Component {
    render() {
        const { data } = this.props;
        return (
            <OurImpact {...data} />
        );
    }
}
